module.exports = __webpack_public_path__ + "img/belgium-neoplasm-female.743c5e39.png";